module.exports = __webpack_public_path__ + "img/plan1-max.671dff1b.png";